<template>
    <div class="anchorSet">
        <el-dialog title="主播设置" :visible.sync="isShow">
            <el-button type="primary" plain @click="addAnchor" :disabled="isEnd">+添加主播</el-button>
            <div class="result-list tableList">
                <el-table :data="tableData">
                    <el-table-column property="" label="主播" width="200">
                        <template slot-scope="scope">
                            <div class="anchorHead">
                                <img class="anchorLogo" :src="scope.row.customerurl" alt="">
                                <span>{{scope.row.customername}}</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column property="" label="标签设置" class-name="center">
                        <template slot-scope="scope">
                            <div class="noEdit" v-show="!scope.row.istag" @click="edit(scope.row,scope.$index)">{{scope.row.tag}} <img :src="pen" alt=""></div>
                            <div class="editInput" v-show="scope.row.istag">
                                <el-input :ref="'inputEdit-'+scope.$index"  size="mini" @blur="editComplete(scope.row)" v-model="scope.row.tag" :disabled="isEnd"></el-input>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column property="address" label="接受用户打赏" class-name="center">
                        <template slot-scope="scope">
                            <el-switch v-model="scope.row.isrcvreaward"  :active-value=1 :inactive-value=0  :disabled="isEnd"></el-switch>
                        </template>
                    </el-table-column>
                    <el-table-column property="address" label="操作" class-name="delText" label-class-name="tr">
                        <template slot-scope="scope">
                            <span  @click="handleDel(scope.row,scope.$index)" v-if="!isEnd">删除</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="btn" v-if="!isEnd">
                <el-button type="" @click="cancel">取消</el-button>
                <el-button type="primary" @click="saveEvent">保存</el-button>
            </div>
        </el-dialog>
        <AddAnchor ref="addAnchor" @getTable="_getTable"></AddAnchor>
    </div>
</template>

<script>
    import {getLiveEventHeaderList,uploadLiveEventHeaderInfo} from 'api/vliveV2Api'
    import {mapGetters, mapActions} from 'vuex'
    import AddAnchor from '@/views/vliveV2/components/addAnchor'
    export default {
        name: "anchorSet",
        data(){
            return{
                pen:require('@/common/images/vliveV2/pen.png'),
                isOpen:'1',
                istagTag:false,
                isShow:false,
                tableData:[],
                liveid:'',
                isEnd:false,
            }
        },
        methods: {
            open(id,status) {
                console.log(status)
                this.liveid=id
                if(status==10||status==100){
                    this.isEnd=true
                }else{
                    this.isEnd=false
                }
                // this.isEnd=[10,100].indexOf(status)>=0
                this._getList()
                this.isShow = true
            },
            //获取主播列表
            _getList(){
                this.setLoading(true)
                let params={
                    liveid:this.liveid
                }
                getLiveEventHeaderList({
                    data: Object.assign({}, params),
                    success: data => {
                        this.setLoading(false)
                        this.tableData=data.data
                        // this.tableData.forEach(obj => {
                        //     obj.isrcvreaward=obj.isrcvreaward==1?true:false
                        // })
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            },
            //主播列表回调
            _getTable(list){
                let arr = this.tableData.map(item=>{
                    return item.customerid
                })
                list.forEach(item=>{
                    console.log()
                    if(!arr.includes(item.customerid)){
                        this.tableData.push(item)
                    }
                })

                // this.tableData.push(list);
                // this.tableData=Array.from(new Set(this.tableData));
                // console.log(this.tableData)
                // this.tableData=this.tableData.concat(list)
                // this.tableData.forEach(obj => {
                //     obj.isrcvreaward=obj.isrcvreaward==1?true:false
                // })
            },
            //添加主播
            addAnchor() {
                this.$refs.addAnchor.open(this.liveid);
            },
            //主播标签设置
            edit(row,index) {
                if(!this.isEnd){
                    row.istag = true
                    this.changeFous(index)
                }
            },
            //编辑完成
            editComplete(row) {
                row.istag = false
            },
            //删除
            handleDel(row,index) {
                this.$confirm(`确认删除该主播吗？`, '提示', {
                }).then(() => {
                    this.tableData.splice(index,1);
                    // this.$message({
                    //     type: 'success',
                    //     message: '删除成功'
                    // })
                }).catch(() => {})
            },

            //保存
            saveEvent() {
                // this.tableData.forEach(obj => {
                //     obj.isrcvreaward=obj.isrcvreaward==true?1:0
                // })
                this.setLoading(true)
                let params={
                    liveid:this.liveid,
                    headerlist:this.tableData
                }
                uploadLiveEventHeaderInfo({
                    data: Object.assign({}, params),
                    success: data => {
                        this.setLoading(false)
                        this.$message({
                            type: 'success',
                            message: '保存成功'
                        })
                        this.isShow = false
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            },
            //取消
            cancel() {
                this.isShow = false
            },
            //输入框聚焦
            changeFous(index){
                let str = 'input'+index;
                console.log(this.$refs[`inputEdit-${index}`])
                this.$nextTick(() => {
                    this.$refs[`inputEdit-${index}`].focus();
                });
            },
            ...mapActions([
                'setLoading'
            ]),
        },
        components: {
            AddAnchor
        },
        computed: {
            ...mapGetters([
                'loading',
            ])
        }
    }
</script>

<style lang="scss">
    @import "~common/scss/base";
    @import "~common/scss/mixin";
    .anchorSet{
        .el-dialog {
            width: 700px;
        }
        .el-dialog .el-button{
            margin-bottom: 20px;
        }
        .tableList{
            .el-table__body-wrapper{
                overflow-y: scroll;
                max-height: 300px;
            }
        }
        .result-list{
            .anchorHead{
                display: flex;
                align-items: center;
                color: #666;
                .anchorLogo{
                    min-width: 40px;
                    width: 40px;
                    height: 40px;
                    border-radius: 50%;
                    margin-right: 10px;
                }
            }
            .delText{
                .cell{
                    text-align: right;
                    margin-right: 20px;
                    span{
                        color: #409EFF;
                        cursor: pointer;
                    }
                }
            }
            .noEdit{
                cursor: pointer;
                img{
                    vertical-align: text-top;
                }
            }
            .editInput{
                .el-input{
                    width: 100px;
                }
                .el-input__inner{
                    text-align: center;
                }
            }
            .center{
                .cell{
                    text-align: center;
                }
            }
            .el-table td{
                padding: 0 0;
            }
            .el-table__row {
                height: 60px;
            }
            /*操作标题位置更改*/
           .el-table__header-wrapper .delText > .cell{
               padding-right: 30px;
           }
        }
        .btn{
            text-align: center;
            padding-top: 20px;
            position: fixed;
            background: #fff;
            width: 700px;
            margin-left: -20px;
        }
        /* 设置滚动条的样式 */
        ::-webkit-scrollbar {
            width:8px;
            background-color: #ededed;
        }
        /* 滚动槽 */
        ::-webkit-scrollbar-track {
            border-radius:10px;
        }
        /* 滚动条滑块 */
        ::-webkit-scrollbar-thumb {
            border-radius:10px;
            background:#cccccc;
        }
    }
</style>
